// extracted by mini-css-extract-plugin
export default {"root":"SecondaryHeader-root_J2pdi","wrapper":"SecondaryHeader-wrapper_DXgBZ"};